// core
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

// services
import { SdkDataService } from '../services/data.service';

@Injectable({
  providedIn: 'root'
})
export class SdkApiService {

  public country: string;
  public product: string;
  public step: number;
  public data: object;

  constructor(private sdkDataService: SdkDataService) {
    this.country = 'nz';
    this.product = 'home';
    this.step = 1;
    this.data = {};
  }


  next() {
    if (this.step < 20) {
      this.step++;
    }

    var fileToken = this.sdkDataService.buildDataToken(this.country, this.product, "quote", this.step);
    return this.sdkDataService.getFile(fileToken).then(data => {
      return data;
    });
  }

  back() {
    if (this.step > 1) {
      this.step--;
    }

    var fileToken = this.sdkDataService.buildDataToken(this.country, this.product, "quote", this.step);
    return this.sdkDataService.getFile(fileToken).then(data => {
      return data;
    });
  }

  getAutoComplete() {
    var fileToken = this.sdkDataService.buildDataToken(this.country, this.product, "address", 1);
    return new Observable(subscriber => {
      this.sdkDataService.getFile(fileToken).then(data => {
        subscriber.next(data);
        subscriber.complete();
      });
    });
  }

  // Set the step data, this is a shortcut function to allow the pasting of an api response object into a form field for debugging,
  // also the validation and parsing of config data through the emulator
  set(data: string) {
    this.data = JSON.parse(data);
  }

  // This holds state data to represent the backend(it is not provided by the module)
  // Needs a reset function that is called on hadover, and a set function if passing route params to form flow
  reset() {
    this.country = 'nz';
    this.product = 'home';
    this.step = 1;
    this.data = {};
  }
}
